<template>
  <div>
    <b-modal
      id="modal-role"
      ref="my-modal"
      cancel-variant="outline-secondary"
      :title="$t('DEBTIA_ADD_MODULE')"
      no-close-on-backdrop
      hide-footer
      :size="moduleID === 8 || moduleID === 25 ? 'lg' : ''"
      @hidden="resetModuleModal"
    >
      <b-card
        border-variant="success"
        bg-variant="transparent"
        class="shadow-none module-card"
      >
        <b-form>
          <b-row>
            <b-col md="12">
              <b-form-group
                :label="$t('DEBTIA_MODULE_TEXT')"
                label-for="debtor-type"
              >
                <v-select
                  v-model="moduleID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="moduleOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  input-id="modules"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
      <Await
        v-if="moduleID === 1"
        :condition-object="conditionObject"
        @closeAwaitModal="closeModal($event)"
      />
      <Condition
        v-if="moduleID === 2"
        :condition-object="conditionObject"
        @closeConditionModal="closeModal($event)"
      />
      <SendLetter
        v-if="moduleID === 3"
        :condition-object="conditionObject"
        @closeSendLetterModal="closeModal($event)"
      />
      <SendEmail
        v-if="moduleID === 4"
        :condition-object="conditionObject"
        @closeSendEmailModal="closeModal($event)"
      />
      <ChangeState
        v-if="moduleID === 5"
        :condition-object="conditionObject"
        @closeChangeStateModal="closeModal($event)"
      />
      <Action
        v-if="moduleID === 6"
        :condition-object="conditionObject"
        @closeActionModal="closeModal($event)"
      />
      <FeeReminder
        v-if="moduleID === 7"
        :condition-object="conditionObject"
        @closeReminderFeeModal="closeModal($event)"
      />
      <save-invoice
        v-if="moduleID === 8"
        :condition-object="conditionObject"
        @closeReminderFeeModal="closeModal($event)"
      />

      <user-action
        v-if="moduleID === 9"
        :condition-object="conditionObject"
        @closeUserActionModal="closeModal($event)"
      />
      <task-list
        v-if="moduleID === 10"
        :condition-object="conditionObject"
        @closeTaskListModal="closeModal($event)"
      />
      <CompensationFee
        v-if="moduleID === 11"
        :condition-object="conditionObject"
        @closeReminderFeeModal="closeModal($event)"
      />
      <CollectionCost
        v-if="moduleID === 12"
        :condition-object="conditionObject"
        @closeReminderFeeModal="closeModal($event)"
      />
      <CollectionFee
        v-if="moduleID === 13"
        :condition-object="conditionObject"
        @closeCollectionFeeModal="closeModal($event)"
      />
      <TimedCondition
        v-if="moduleID === 14"
        :condition-object="conditionObject"
        @closeConditionModal="closeModal($event)"
      />
      <CustomFieldData
        v-if="moduleID === 15"
        :condition-object="conditionObject"
        @closeCustomDataModal="closeModal($event)"
      />
      <change-termsheet
        v-if="moduleID === 16"
        :condition-object="conditionObject"
        @closeTermsheetModal="closeModal($event)"
      />
      <bailiff
        v-if="moduleID === 17"
        :condition-object="conditionObject"
        @closeBailiffModal="closeModal($event)"
      />
      <bailiff-case
        v-if="moduleID === 18"
        :condition-object="conditionObject"
        @closeBailiffModal="closeModal($event)"
      />
      <transfer-court-fee
        v-if="moduleID === 19"
        :condition-object="conditionObject"
        @closeTransferCourtModal="closeModal($event)"
      />
      <RegisterRKIDebtor
        v-if="moduleID === 20"
        :condition-object="conditionObject"
        @closeRegisterRKIModal="closeModal($event)"
      />
      <delete-r-k-i-registration
        v-if="moduleID === 21"
        :condition-object="conditionObject"
        @closeRegisterRKIModal="closeModal($event)"
      />
      <bailiff-process
        v-if="moduleID === 22"
        :condition-object="conditionObject"
        @closeBailiffModal="closeModal($event)"
      />
      <overvagning-termsheet
        v-if="moduleID === 23"
        :condition-object="conditionObject"
        @closeOvervagningModal="closeModal($event)"
      />
      <await-till-date
        v-if="moduleID === 24"
        :condition-object="conditionObject"
        @closeAwaitTillDateModal="closeModal($event)"
      />
      <content-condition-module
        v-if="moduleID === 25"
        :condition-object="conditionObject"
        @closeContentConditionModal="closeModal($event)"
      />
      <deactivate-installment
        v-if="moduleID === 26"
        :condition-object="conditionObject"
        @closeInstallmentPlanModal="closeModal($event)"
      />

    </b-modal>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import {
  BCard,
  BFormGroup,
  // BFormInput,
  // BButton,
  BForm,
  BRow,
  BCol,
} from 'bootstrap-vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Await from './modules/Await.vue'
import Condition from './modules/Condition.vue'
import SendLetter from './modules/SendLetter.vue'
import SendEmail from './modules/SendEmail.vue'
import ChangeState from './modules/ChangeState.vue'
import Action from './modules/Action.vue'
import FeeReminder from './modules/FeeReminder.vue'
import SaveInvoice from './modules/SaveInvoice.vue'
import UserAction from './modules/RequireUserAction.vue'
import TaskList from './modules/TaskList.vue'
import CompensationFee from './modules/CompensationFee.vue'
import CollectionCost from './modules/CollectionCost.vue'
import CollectionFee from './modules/CollectionFee.vue'
import TimedCondition from './modules/TimedCondition.vue'
import CustomFieldData from './modules/CustomFieldData.vue'
import ChangeTermsheet from './modules/ChangeTermsheet.vue'
import Bailiff from './modules/Bailiff.vue'
import BailiffCase from './modules/BailiffCase.vue'
import TransferCourtFee from './modules/TransferCourtFee.vue'
import RegisterRKIDebtor from './modules/RegisterRKIDebtor.vue'
import DeleteRKIRegistration from './modules/DeleteRKIRegistration.vue'
import BailiffProcess from './modules/BailiffProcess.vue'
import OvervagningTermsheet from './modules/OvervagningTermsheet.vue'
import ContentConditionModule from './modules/ContentConditionModule.vue'
import AwaitTillDate from './modules/AwaitTillDate.vue'
import DeactivateInstallment from './modules/DeactivateInstallment.vue'

export default {
  components: {
    BFormGroup,
    BForm,
    BRow,
    BCol,
    vSelect,
    Await,
    Condition,
    SendLetter,
    SendEmail,
    ChangeState,
    Action,
    BCard,
    FeeReminder,
    SaveInvoice,
    UserAction,
    TaskList,
    CompensationFee,
    CollectionCost,
    CollectionFee,
    TimedCondition,
    CustomFieldData,
    ChangeTermsheet,
    Bailiff,
    BailiffCase,
    TransferCourtFee,
    RegisterRKIDebtor,
    DeleteRKIRegistration,
    BailiffProcess,
    OvervagningTermsheet,
    ContentConditionModule,
    AwaitTillDate,
    DeactivateInstallment,
  },
  props: {
    conditionVariant: {
      type: Object,
      required: true,
    },
    conditionCheck: {
      type: Boolean,
      required: true,
    },
    mainCondition: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      moduleID: 0,
      moduleOptions: [
        { label: 'Await Module', value: 1 },
        { label: 'Condition Module', value: 2 },
        { label: 'Send Letter Module', value: 3 },
        { label: 'Send Email module', value: 4 },
        { label: 'Change State Module', value: 5 },
        { label: 'Action Module', value: 6 },
        { label: 'Fee Reminder Module', value: 7 },
        { label: 'Send Invoice Module', value: 8 },
        { label: 'User Action Module', value: 9 },
        { label: 'Task List Module', value: 10 },
        { label: 'Compensation Fee Module', value: 11 },
        { label: 'Collection Cost Module', value: 12 },
        { label: 'Collection Fee Module', value: 13 },
        { label: 'Timed Condition Module', value: 14 },
        { label: 'Custom Field Data Module', value: 15 },
        { label: 'Change Termsheet Module', value: 16 },
        { label: 'Bailiff Conclusion Popup Module', value: 17 },
        { label: 'Bailiff Case Module', value: 18 },
        { label: 'Transfer Court Fee Module', value: 19 },
        { label: 'Register Debtor RKI Module', value: 20 },
        { label: 'Delete RKI registration of debtor', value: 21 },
        { label: 'Conclude Bailiff Process', value: 22 },
        { label: 'Overvågning Termsheet', value: 23 },
        { label: 'Await Till Date', value: 24 },
        { label: 'Content Condition module', value: 25 },
        { label: 'Deactivate Installment Plan Module', value: 26 },
      ],
      conditionObject: {},
      parentCondition: true,
    }
  },
  watch: {
    conditionCheck: {
      handler() {
        this.conditionObject = this.conditionVariant
        this.parentCondition = this.mainCondition
      },
    },
  },
  created() {
  },
  methods: {
    closeModal(obj) {
      this.moduleID = 0
      this.$refs['my-modal'].hide()
      this.$emit('refreshprocess', obj)
    },
    resetModuleModal() {
      this.moduleID = 0
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  .module-card{
    border: 1px solid #d0d0d0 !important;
    margin-bottom: 10px;
  }
</style>
